(() => {
  if (window.__ylReviewedGalleryDialogReady) return;
  window.__ylReviewedGalleryDialogReady = true;

  document.addEventListener('click', event => {
    const opener = event.target.closest?.('[data-yl-reviewed-enlarge]');
    if (opener) {
      const gallery = opener.closest('.yl-product-gallery--reviewed');
      const frame = opener.closest('[data-yl-media-panel]')?.querySelector('.yl-reviewed-gallery__frame');
      const dialog = gallery?.querySelector('[data-yl-reviewed-dialog]');
      const content = dialog?.querySelector('[data-yl-reviewed-dialog-content]');
      if (!frame || !content || !dialog.showModal) return;
      const enlargedFrame = frame.cloneNode(true);
      const image = enlargedFrame.querySelector('img[data-yl-reviewed-full-src]');
      const fullSrc = image?.getAttribute('data-yl-reviewed-full-src');
      if (fullSrc) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = fullSrc;
        image.loading = 'eager';
      }
      content.replaceChildren(enlargedFrame);
      dialog.__ylReviewedTrigger = opener;
      dialog.showModal();
      dialog.querySelector('[data-yl-reviewed-close]')?.focus();
      return;
    }

    const close = event.target.closest?.('[data-yl-reviewed-close]');
    if (close) {
      close.closest('[data-yl-reviewed-dialog]')?.close();
      return;
    }

    const dialog = event.target.closest?.('[data-yl-reviewed-dialog]');
    if (dialog && event.target === dialog) {
      // Backdrop clicks target the dialog too; padding inside its box is not a backdrop.
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right
        || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });

  document.addEventListener('close', event => {
    const dialog = event.target;
    if (!dialog.matches?.('[data-yl-reviewed-dialog]')) return;
    dialog.querySelector('[data-yl-reviewed-dialog-content]')?.replaceChildren();
    if (dialog.__ylReviewedTrigger?.isConnected) dialog.__ylReviewedTrigger.focus();
    dialog.__ylReviewedTrigger = null;
  }, true);
})();
